module.exports = __webpack_public_path__ + "img/21_84.bf6d61fb.png";